"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderedMapSort = exports.orderedMapUpdate = void 0;
function orderedMapUpdate(map, key, notSetValue, updater) {
    return map.update(key, notSetValue, updater);
}
exports.orderedMapUpdate = orderedMapUpdate;
function orderedMapSort(map, comparator) {
    return map.sort(comparator);
}
exports.orderedMapSort = orderedMapSort;
